"use strict";

var buildBaseUrl = function buildBaseUrl(_ref) {
  var host = _ref.host,
      alias = _ref.alias,
      route = _ref.route,
      token = _ref.token;
  var hostSplit = host.split('://');
  var protocol = hostSplit[0];
  var domain = hostSplit[1];
  var usedAlias = !alias || alias === 'shootsta' ? '' : "".concat(alias, ".");
  var usedRoute = route ? "/".concat(route) : '';
  var usedToken = token ? "?t=".concat(token) : '';
  return "".concat(protocol, "://").concat(usedAlias).concat(domain).concat(usedRoute).concat(usedToken);
};

module.exports = buildBaseUrl;